import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import SearchComponent from '../../PricingHub/SearchComponent';

class VoiceCustomerCallTypeSummarySearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.callType',
      name: 'usageType',
      fa: 'fa fa-external-link',
    },
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'datetime',
      required: true,
      defaultValue: moment(). startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'datetime',
      required: true,
      defaultValue: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.organization',
      name: 'organization',
      fa: 'fa fa-external-link',
    },
  ];

  btnSpan = 'col-md-12';
}

VoiceCustomerCallTypeSummarySearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

VoiceCustomerCallTypeSummarySearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(VoiceCustomerCallTypeSummarySearchForm);
